import type { BuiltInLabel, LabelableEntityBase } from "building-types/entities/labelTypes";
import { EffectType, type Effect, type VisibilityEffect } from "building-types/views/effectTypes";
import {
  SelectionMethod,
  type SerializableSheetGeometrySelector,
} from "building-types/views/SerializableSheetGeometrySelector";
import type { PartialRecord } from "common/utils/types";
import type { SheetGeometrySelector } from "./planGeometrySourceTypes";

/** Maps a view template override id to a selector and its effects */

export interface SheetGeometrySelectorEffectMap {
  readonly selector: SheetGeometrySelector | SerializableSheetGeometrySelector;
  readonly effects: Effect[];
}

export function builtInElevationVisibilitySelectors(): SheetGeometrySelectorEffectMap[] {
  const labels: PartialRecord<BuiltInLabel, true> = { addToExteriorElevation: true };
  return visibilitySelectorsFromLabelFilter(labels);
}

export function builtInPerspectiveVisibilitySelectors(): SheetGeometrySelectorEffectMap[] {
  const labels: PartialRecord<BuiltInLabel, true> = { addToPerspectiveView: true };
  return visibilitySelectorsFromLabelFilter(labels);
}

export function visibilitySelectorsFromLabelFilter(
  filterLabels: LabelableEntityBase["labels"],
): SheetGeometrySelectorEffectMap[] {
  const selector: SerializableSheetGeometrySelector = {
    selectionMethod: SelectionMethod.BY_LABEL,
    labels: filterLabels,
  };
  const visibilityEffect: VisibilityEffect = {
    id: "visibilityEffect",
    entityType: "EFFECT",
    name: "Visibility Effect",
    sortIndex: 0,
    type: EffectType.VISIBILITY,
    categories: [], // Will affect all categories
    invert: true, // Will show only the selected entities
  };
  return [
    {
      selector,
      effects: [visibilityEffect],
    },
  ];
}
